import { useEffect, useRef, useState } from "react";
import { Stack, Box, Text, Tabs, TabList, Tab, TabPanels, TabPanel, Flex, Input, FormLabel, Select, Button, Textarea, FormErrorMessage, FormControl, HStack, Heading } from "@chakra-ui/react";
import 'services/Recruit/assets/css/CreateJobOpening/style.css';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { globalStyles } from "common/theme/styles";
import { Field, Formik, Form } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { constant } from "common/constant";
import ActionNavbar from "common/components/actionBar/ActionNavbar";
import { useDispatch, useSelector } from "react-redux";
import { getDepartments } from "common/redux/reducers/departmentSlice";
import { fetchUserData } from "common/redux/reducers/userSlice";
import { uploadAttachment } from "common/redux/reducers/attachmentSlice";
import { recruitConstant } from "services/Recruit/constant";
import { referralSchema } from "services/Crm/schema/referralSchema";
import { referralsTabs } from "services/Recruit/data/referrals";

const ReferralsCreate = () => {
  const colors = globalStyles.colors;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const { id } = useParams();
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const { users } = useSelector((state) => state.users);

  const handleTabChange = (index) => {
    setActiveTabIndex(index);
  };

  const handleNext = () => {
    if (activeTabIndex < 3) {
      setActiveTabIndex(activeTabIndex + 1);
    }
  };

  const handleBack = () => {
    if (activeTabIndex > 0) {
      setActiveTabIndex(activeTabIndex - 1);
    }
  }

  const handleFileChange = (dispatch, setFieldValue, fieldName) => (e) => {
    const file = e.target.files[0];
    if (file) {
      dispatch(uploadAttachment({ file, setFieldValue: (field, value) => setFieldValue(fieldName, value) }));
    }
  };

  useEffect(() => {
    dispatch(getDepartments());
    dispatch(fetchUserData());
  }, [dispatch]);

  return (
    <Box className="referral-mt" mt={5}>
      <ActionNavbar
        isCreatePage={true}
      />
      <Stack>
        <Box className="createJobOpening-container">
          <Box className='createJobOpening-mainContainer'>
            <Box className='createJobOpening-breadCrumb'>
              <ArrowBackIcon onClick={() => navigate("/recruit/referrals")} fontSize="20px" />
              <Text className='createJobOpening-pageTitle'>{recruitConstant.createReferral}</Text>
            </Box>
          </Box>

          <Formik
            initialValues={{
              referringJob: "",
              firstName: "",
              lastName: "",
              email: "",
              phoneNumber: "",
              jobTitle: "",
              employer: "",
              resume: null,
            }}
            validationSchema={referralSchema}
            onSubmit={(values, { resetForm }) => {
              console.log("Submitted Data:", values);
              resetForm();
              setFileName("");
              navigate("/recruit/referrals");
            }}
          >
            {({ errors, touched, setFieldValue }) => (
              <Form>
                <Tabs index={activeTabIndex} onChange={handleTabChange} className="createJobOpening-tabsContainer" variant="unstyled" orientation="vertical">
                  {/* tab list  */}
                  <TabList w={'40%'} className="createJobOpening-tabListContainer">
                    {referralsTabs.map(({ label, Icon }, index) => (
                      <Tab
                        className="createJobOpening-tabs"
                        key={index}
                        _selected={{
                          color: colors.cta['100'],
                          borderLeft: "2px solid",
                          borderColor: colors.cta['100'],
                        }}
                        _hover={{
                          color: colors.cta['100'],
                        }}
                        _focus={{ boxShadow: "none" }}
                        display="flex"
                        alignItems="center"
                        gap="8px"
                      >
                        <Icon size={20} />
                        {label}
                      </Tab>
                    ))}
                  </TabList>

                  {/* tab panels */}
                  <TabPanels w={'60%'} className="createJobOpening-tabsPanelContainer">
                    {/* job opening tab */}
                    <TabPanel className="createJobOpening-tabsPanel">
                      <section className="createJobOpening-tabsPanelBody">
                        <FormControl isInvalid={errors.resume && touched.resume}>
                          <FormLabel className="headLabel">{constant.uploadResume}<span className="astrick">*</span></FormLabel>
                          <Input
                            type="file"
                            hidden
                            ref={fileInputRef}
                            accept=".doc,.docx,.rtf,.pdf"
                            onChange={(event) => {
                              const file = event.target.files[0];
                              if (file) {
                                setFileName(file.name);
                                setFieldValue("resume", file);
                              }
                            }}
                          />
                          <Box
                            className="upload-box"
                            onClick={() => fileInputRef.current.click()}
                          >
                            <Text className="upload-text">{constant.uploadResume}</Text>
                            <Text className="upload-info">
                              {fileName
                                ? fileName
                                : "Supported Formats: doc, docx, rtf, pdf, up to 2 MB"}
                            </Text>
                          </Box>
                          <FormErrorMessage>{errors.resume}</FormErrorMessage>
                        </FormControl>

                        <Heading mt={"28px"} className="headLabel">
                          {constant.robRecommendation}
                        </Heading>
                        <FormControl
                          isInvalid={errors.referringJob && touched.referringJob}
                        >
                          <FormLabel>{constant.referringForJob}<span className="astrick">*</span></FormLabel>
                          <Field
                            as={Input}
                            name="referringJob"
                            placeholder={recruitConstant.enterReferral}
                          />
                          <FormErrorMessage>{errors.referringJob}</FormErrorMessage>
                        </FormControl>
                        <HStack spacing={4}>
                          <FormControl isInvalid={errors.firstName && touched.firstName}>
                            <FormLabel>{constant.firstName}<span className="astrick">*</span></FormLabel>
                            <Field
                              as={Input}
                              name="firstName"
                              placeholder={recruitConstant.enterFirstName}
                            />
                            <FormErrorMessage>{errors.firstName}</FormErrorMessage>
                          </FormControl>
                          <FormControl isInvalid={errors.lastName && touched.lastName}>
                            <FormLabel>{constant.lastName}<span className="astrick">*</span></FormLabel>
                            <Field
                              as={Input}
                              name="lastName"
                              placeholder={recruitConstant.enterLirstName}
                            />
                            <FormErrorMessage>{errors.lastName}</FormErrorMessage>
                          </FormControl>
                        </HStack>
                        <HStack spacing={4}>
                          <FormControl isInvalid={errors.email && touched.email}>
                            <FormLabel>{constant.email}<span className="astrick">*</span></FormLabel>
                            <Field
                              as={Input}
                              name="email"
                              placeholder={recruitConstant.enterEmailId}
                            />
                            <FormErrorMessage>{errors.email}</FormErrorMessage>
                          </FormControl>
                          <FormControl
                            isInvalid={errors.phoneNumber && touched.phoneNumber}
                          >
                            <FormLabel>{constant.phoneNumber}<span className="astrick">*</span></FormLabel>
                            <Field
                              as={Input}
                              name="phoneNumber"
                              placeholder={recruitConstant.enterPhoneNumber}
                            />
                            <FormErrorMessage>{errors.phoneNumber}</FormErrorMessage>
                          </FormControl>
                        </HStack>
                        <HStack spacing={4}>
                          <FormControl isInvalid={errors.jobTitle && touched.jobTitle}>
                            <FormLabel>{constant.currentJobTitle}<span className="astrick">*</span></FormLabel>
                            <Field
                              as={Input}
                              name="jobTitle"
                              placeholder={recruitConstant.enterCurrentRole}
                            />
                            <FormErrorMessage>{errors.jobTitle}</FormErrorMessage>
                          </FormControl>
                          <FormControl isInvalid={errors.employer && touched.employer}>
                            <FormLabel>{constant.currentEmployer}<span className="astrick">*</span></FormLabel>
                            <Field
                              as={Input}
                              name="employer"
                              placeholder={recruitConstant.enterEmployer}
                            />
                            <FormErrorMessage>{errors.employer}</FormErrorMessage>
                          </FormControl>
                        </HStack>
                        <div>
                          <Flex justifyContent="flex-end" mt={4} gap={3}>
                            <Button
                              variant="primary"
                              className="backBtn"
                              onClick={() => navigate("/recruit/referrals")}
                            >
                              {constant.back}
                            </Button>
                            <Button type="submit" colorScheme="purple" onClick={() => navigate("/recruit/referrals")}>
                              {id ? constant.update : constant.save}
                            </Button>
                          </Flex>
                        </div>
                      </section>
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </Form>
            )}
          </Formik>
        </Box>
      </Stack>
    </Box>
  );
};

export default ReferralsCreate;
